import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IdpDuoIcon extends BaseIcon {
  getChildren = () => [
    <defs>
      <clipPath id="idp-duo">
        <path transform="translate(-16780 -18683.959)" fill="#fbb" opacity=".7" d="M0 0h70v50H0z"/>
      </clipPath>
    </defs>,
    <g transform="translate(16780 18683.959)" clipPath="url(#idp-duo)">
      <g opacity=".85">
        <g>
          <path d="M-16756.629-18658.391h-21.097v10.817h10.56c5.651 0 10.265-4.789 10.538-10.821" fill="#6dbe50"/>
        </g>
      </g>
      <path d="M-16767.166-18670.346h-10.56v10.821h21.108c-.284-6.032-4.9-10.821-10.549-10.821" fill="#6dbe50"/>
      <path d="M-16722.822-18670.346c-5.651 0-10.276 4.8-10.549 10.821h21.085c-.262-6.032-4.887-10.821-10.538-10.821" fill="#6dbe50"/>
      <g opacity=".85">
        <g>
          <path d="M-16712.275-18658.391h-21.097c.273 6.033 4.887 10.817 10.55 10.817s10.276-4.789 10.549-10.821" fill="#6dbe50"/>
        </g>
      </g>
      <path d="M-16755.559-18670.346v11.388c0 6.1 4.44 11.083 10.036 11.378v-22.766Z" fill="#6dbe50"/>
      <g opacity=".85">
        <g>
          <path d="M-16734.441-18670.346h-10.025v22.777h10.025v-22.777Z" fill="#6dbe50"/>
        </g>
      </g>
    </g>
  ]
  getViewBox = () => '0 0 70 50'
}
